
	import Vue from "vue"
	import Component from "vue-class-component"
	import ContentHeader from "custom/ContentHeader.vue"
	import PNavigationTabs from "@portal-components/ui/navigation/PNavigationTabs.vue"
	import PNavigationTabItem from "@portal-components/ui/navigation/PNavigationTabItem.vue"

	import MyDetails from "custom/profile/MyDetails.vue"
	import MyCompanyDetails from "custom/profile/MyCompanyDetails.vue"
	import MyCompany from "custom/profile/MyCompany.vue"
	import MyAdvisor from "custom/profile/MyAdvisor.vue"
	import Page from "custom/Page.vue"
	import PageSlide from "@components/container/PageSlide.vue"
	import Secured from "utils/security/Secured"
	import { Ref } from "vue-property-decorator"
	import { sessionFactory } from "utils/session-factory"
	import { userModule } from "store/modules"
	import { User } from "store/user/types"

	@Secured(sessionFactory.session)
	@Component({
		components: {
			ContentHeader,
			PNavigationTabs,
			PNavigationTabItem,
			Page,
			PageSlide,
			MyDetails,
			MyCompany,
			MyAdvisor,
			MyCompanyDetails
		}
	})
	export default class Profile extends Vue {
		@userModule.Getter user!: User

		@Ref() private readonly profileTabs?: PNavigationTabs

		readonly baseTranslationKey = "profile"

		mounted(): void {
			const urlParams = new URLSearchParams(window.location.search)
			const tabKey = urlParams.get("tab")

			if (tabKey === null) {
				return
			}

			this.profileTabs?.setActiveTab(tabKey)
		}
	}
